<template>
  <div class="w-full py-1">
    <div class="flex">
      <div class="w-1/4">
        <div class="relative mb-2">
          <div
            class="w-10 h-10 mx-auto bg-blue-500 rounded-full text-lg flex items-center"
          >
            <span class="text-center text-white w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="text-xs text-center md:text-base">User Details</div>
      </div>

      <div class="w-1/4">
        <div class="relative mb-2">
          <div
            class="absolute flex align-center items-center align-middle content-center"
            style="
              width: calc(100% - 2.5rem - 1rem);
              top: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <div
              class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1"
            >
              <div
                class="w-0 py-1 rounded"
                :class="[
                  currentState >= currentState - (currentState - 1)
                    ? 'bg-blue-500'
                    : '',
                ]"
                style="width: 100%"
              ></div>
            </div>
          </div>

          <div
            class="w-10 h-10 mx-auto bg-blue-500 rounded-full text-lg text-white flex items-center"
          >
            <span class="text-center text-white w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="text-xs text-center md:text-base">Educational Details</div>
      </div>

      <div class="w-1/4">
        <div class="relative mb-2">
          <div
            class="absolute flex align-center items-center align-middle content-center"
            style="
              width: calc(100% - 2.5rem - 1rem);
              top: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <div
              class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1"
            >
              <div
                class="w-0 py-1 rounded"
                :class="[
                  currentState >= currentState - (currentState - 2)
                    ? 'bg-blue-500'
                    : '',
                ]"
                style="width: 100%"
              ></div>
            </div>
          </div>

          <div
            class="w-10 h-10 mx-auto bg-blue-500 rounded-full text-lg text-white flex items-center"
          >
            <span class="text-center w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="text-xs text-center md:text-base">Employment Record</div>
      </div>

      <div class="w-1/4">
        <div class="relative mb-2">
          <div
            class="absolute flex align-center items-center align-middle content-center"
            style="
              width: calc(100% - 2.5rem - 1rem);
              top: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <div
              class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1"
            >
              <div
                class="w-0 py-1 rounded"
                :class="[
                  currentState >= currentState - (currentState - 3)
                    ? 'bg-blue-500'
                    : '',
                ]"
                style="width: 100%"
              ></div>
            </div>
          </div>

          <div
            class="w-10 h-10 mx-auto bg-blue-500 rounded-full text-lg text-white flex items-center"
          >
            <span class="text-center w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="text-xs text-center md:text-base">Languages</div>
      </div>
      <div class="w-1/4">
        <div class="relative mb-2">
          <div
            class="absolute flex align-center items-center align-middle content-center"
            style="
              width: calc(100% - 2.5rem - 1rem);
              top: 50%;
              transform: translate(-50%, -50%);
            "
          >
            <div
              class="w-full bg-gray-200 rounded items-center align-middle align-center flex-1"
            >
              <div
                class="w-0 py-1 rounded"
                :class="[
                  currentState >= currentState - (currentState - 4)
                    ? 'bg-blue-500'
                    : '',
                ]"
                style="width: 100%"
              ></div>
            </div>
          </div>

          <div
            class="w-10 h-10 mx-auto bg-blue-500 rounded-full text-lg text-white flex items-center"
          >
            <span class="text-center text-white w-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-7 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="text-xs text-center md:text-base">Expectations</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Progress Bar",
  props: ["currentState", "steps"],
};
</script>

<style></style>
